import UnbindMemberSignUpVue from '@/views/unbind-member/sign-up/sign-up.vue';

const basePath = '/unbindMember/sign-up';
const role = 'unbind-member'; // 角色身份

export const U_M_SIGN_UP_INDEX = 'u-m-sign-up';
export const U_M_SIGN_UP_SUCCESS = 'u-m-sign-up-success';
export const U_M_SIGN_UP_FAIL = 'u-m-sign-up-fail';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: UnbindMemberSignUpVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: U_M_SIGN_UP_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/sign-up/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: U_M_SIGN_UP_SUCCESS,
      props: true,
      component: () => import(
        /* webpackChunkName: "sign-up-success" */
        `@/views/${role}/sign-up/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/fail`,
      name: U_M_SIGN_UP_FAIL,
      component: () => import(
        /* webpackChunkName: "sign-up-fail" */
        `@/views/${role}/sign-up/fail.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
